import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ImgLoader from 'components/common/ImgLoader';
import './Thumbnail.css';

const Thumbnail = (props) => {
	const figure = <Figure {...props} />;
	let ratio;
	if (props.width === props.height) {
		ratio = 'square';
	} else if (props.width > props.height) {
		ratio = 'landscape';
	} else {
		ratio = 'portrait';
	}
	let className = 'Thumbnail';
	className += ' ratio-' + ratio;
	return (props.slug) ? 
		<Link className={className} to={'/'+props.slug}>{figure}</Link> :
		<div className={className}>{figure}</div>
}
const Figure = (props) => {
	const { title, row2, year, client, src, hex, width, height, wait } = props;
	return (
		<figure data-hex={hex} data-title={[title, row2]}>
			{ src && <ImgLoader src={src} alt={title + ' ' + row2} width={width} height={height} hex={hex} wait={wait} /> }
			<figcaption>
				{ (title || row2) && 
					<span className="meta-title">
						<span className="meta-title-row1">{title}</span> <span className="meta-title-row2">{row2}</span>
					</span>
				}
				{ year && <span className="meta-year">{year}</span> }
				{ client && <span className="meta-client">{client}</span> }
			</figcaption>
		</figure>
	)
}
Thumbnail.propTypes = {
	slug: PropTypes.string,
	title: PropTypes.string,
	row2: PropTypes.string,
	year: PropTypes.string,
	client: PropTypes.string,
	src: PropTypes.string,
	hex: PropTypes.string,
	width: PropTypes.number,
	height: PropTypes.number,
	wait: PropTypes.bool,
}

export default Thumbnail;


// WEBPACK FOOTER //
// ./src/components/common/Thumbnail.jsx